interface ScrollState {
  completionPercentage: number;
  lastCompletionPercentage: number;
}

const SELECTOR = {
  main: ".js-secondary-content-reveal",
  primaryContent: ".js-secondary-content-reveal-primary-content",
  secondaryContent: ".js-secondary-content-reveal-secondary-content",
};

const CSS = {
  active: "secondary-content-reveal--active",
  complete: "secondary-content-reveal--complete",
  secondContentReveal: "secondary-content-reveal--reveal",
};

const secondaryContentRevealActiveThreshold = 5;
const secondaryContentRevealPercentage = 60;

const secondaryContentRevealAnimationFrameVariableName =
  "secondaryContentRevealAnimationFrame";

const getScrollState = (): ScrollState => ({
  completionPercentage: 0,
  lastCompletionPercentage: 0,
});

const calculateCompletionPercentage = (
  $el: HTMLElement,
  verticalOffsetEnd: number = 0,
): number => {
  const start = $el.offsetTop;
  const end = $el.offsetTop + $el.clientHeight - verticalOffsetEnd;

  if (window.scrollY < start) {
    return 0;
  }

  if (window.scrollY > end) {
    return 100;
  }

  const totalScrollDistance = end - start;
  const currentScrollDistance = window.scrollY - start;

  return Math.floor((currentScrollDistance / totalScrollDistance) * 100);
};

const updateAnimationState = ($el: Element, scrollState: ScrollState) => {
  const offsetHeight = $el.querySelector(SELECTOR.primaryContent)!.clientHeight;

  scrollState.completionPercentage = calculateCompletionPercentage(
    $el as HTMLElement,
    offsetHeight,
  );

  if (
    scrollState.completionPercentage == scrollState.lastCompletionPercentage
  ) {
    ($el as HTMLElement).style.setProperty(
      `--${secondaryContentRevealAnimationFrameVariableName}`,
      "0ms",
    );

    return;
  }

  if (
    scrollState.completionPercentage > secondaryContentRevealActiveThreshold &&
    scrollState.completionPercentage < 100
  ) {
    $el.classList.add(CSS.active);
  } else {
    $el.classList.remove(CSS.active);
  }

  if (scrollState.completionPercentage >= secondaryContentRevealPercentage) {
    $el.classList.add(CSS.secondContentReveal);
  } else {
    $el.classList.remove(CSS.secondContentReveal);
  }

  if (
    scrollState.completionPercentage >
    100 - secondaryContentRevealActiveThreshold
  ) {
    $el.classList.add(CSS.complete);
  } else {
    $el.classList.remove(CSS.complete);
  }

  let animationFrame = -(scrollState.completionPercentage * 10);
  if (animationFrame == -1000) {
    animationFrame = -999;
  }

  ($el as HTMLElement).style.setProperty(
    `--${secondaryContentRevealAnimationFrameVariableName}`,
    `${animationFrame}ms`,
  );
};

const instance = ($el: Element, scrollState: ScrollState) => {
  const primaryContent = $el.querySelector(SELECTOR.primaryContent);
  const secondaryContent = $el.querySelector(SELECTOR.secondaryContent);

  if (!primaryContent || !secondaryContent) {
    return;
  }

  window.addEventListener("scroll", () => {
    updateAnimationState($el, scrollState);
  });
  updateAnimationState($el, scrollState);
};

const secondaryContentReveal = () => {
  document.querySelectorAll(SELECTOR.main).forEach(($el: Element) => {
    const scrollState = getScrollState();
    instance($el, scrollState);
  });
};

export default secondaryContentReveal;
